const COMPANY_TYPES = {
    business: 'Business',
    organization: 'Charity',
};

export default COMPANY_TYPES;

export const isSoleTrader = type => type === 'soleTrader';

export const TRANSLATE_COMPANY_TYPES = t =>
    Object.keys(COMPANY_TYPES).reduce((acc, key) => ({...acc, [key]: t(`b2bCompanyTypes.${key}`)}), {});
